import React, { useState, useEffect } from "react";

import { DocumentReference, QueryDocumentSnapshot } from "firebase/firestore";
import { onSnapshot, where, query, collection } from "firebase/firestore";

import { useParams } from "react-router-dom";
import { Tabs } from "@mantine/core";

import { History } from "../../components/history";


import { IpoRequestObject, } from "../../types";
import { useFirestore } from "../../helpers/firebaseContext";
import IpoRequestInfo from "./ipo_request_info";


//create CustomerInfo component
export default function IpoRequestPage(props: any) {
  const { id } = useParams();

  const db = useFirestore();
  const [ipoRequestData, setIPORequestData] = useState<IpoRequestObject>();
  const [ipoRequestDocument, setIPORequestDocument] = useState<QueryDocumentSnapshot<IpoRequestObject>>();

  const [ipoRequestRef, setIPORequestRef] = useState<DocumentReference>();



  // const navigate = useNavigate();

  // const tabValue = null;
  const [activeTab, setActiveTab] = React.useState<string | null>("info");

  useEffect(() => {
    const ipoRequestQuerySnapshot = query(collection(db, "ipoRequests"), where('id', '==', id))
    return onSnapshot(
      ipoRequestQuerySnapshot,
      (snapshot) => {

        if (!snapshot.empty) {

          const ipoRequestRef = snapshot?.docs[0] as QueryDocumentSnapshot<IpoRequestObject>;
          setIPORequestDocument(ipoRequestRef)
          const ipoRequestData = ipoRequestRef.data();
          setIPORequestRef(snapshot?.docs[0].ref);
          setIPORequestData(ipoRequestData as IpoRequestObject)

        }
        else {
          console.log("SANPSHOTTT  IS  EMPTYYY====>>>", snapshot);

        }
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!ipoRequestData || !ipoRequestRef) {

    return <div>Loading...</div>
  }

  console.log("IPORequest is", ipoRequestData);

  return (
    <>
      {/* <Tabs defaultValue="kyc" value={tabValue} onChange={(value: any) => navigate(`/customers/${id}/${value}`)}> */}
      <Tabs onChange={setActiveTab} value={activeTab}>
        <Tabs.List>
          <Tabs.Tab
            value="info"
          >
            Info
          </Tabs.Tab>
          <Tabs.Tab value="history">History</Tabs.Tab>
        </Tabs.List>


        <Tabs.Panel value="info">
          <IpoRequestInfo ipoRequestDoc={ipoRequestDocument} ipoRequest={ipoRequestData} ipoRequestRef={ipoRequestRef} />
        </Tabs.Panel >


        <Tabs.Panel value="history">
          {ipoRequestData && <History
            historyCollection={collection(
              ipoRequestRef,
              "history"
            )}
          />}

        </Tabs.Panel>
      </Tabs >
    </>
  );
}
